import defaultOG from '@/assets/default-og';

export function generateMeta(options) {
  const { title, description, includeDefaults = true } = options;
  const defaultMeta = includeDefaults ? defaultOG : [];
  return {
    title,
    meta: [
      {
        hid: 'og:title',
        name: 'og:title',
        content: title,
      },
      {
        hid: 'description',
        name: 'description',
        content: description,
      },
      {
        hid: 'og:description',
        name: 'og:description',
        content: description,
      },
      ...defaultMeta,
    ],
  };
}
